// extracted by mini-css-extract-plugin
export var backdropBlur = "_82-0";
export var body = "_82-5";
export var bodyScroll = "_82-6";
export var columnFooter = "_82-7";
export var columnFooterFlush = "_82-8";
export var contentColumn = "_82-4";
export var frame = "_82-3";
export var heroContent = "_82-c";
export var heroOverlay = "_82-b";
export var image = "_82-a";
export var imageWrapper = "_82-9";
export var modal = "_82-1";
export var modalMain = "_82-2";
export var productHeader = "_82-d";
export var productHeaderIcon = "_82-e";
export var productHeaderName = "_82-f";
export var progressIndicator = "_82-g";